module.exports = __webpack_public_path__ + "static/media/home-banner@2x.aca5ad09.jpg";